import { Component, OnInit } from '@angular/core';

import { SvgIconsModule } from '@library/common/materials';

@Component({
   selector: 'lib-template-wrapper',
   template: `<router-outlet></router-outlet>`,
})
export class TemplateWrapperComponent implements OnInit {

   constructor( private svgIcons: SvgIconsModule ) { }

   ngOnInit() {
      this.svgIcons.register( 'createshipment' );

      window.scrollTo(0, 0);
   }
}
